var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { SliceLayoutBoundary } from './slice-layout';
import { ActiveEntityProvider } from '../context';
import { useKnowledgeHubPage } from '../../hooks';
import { PageHeader, PageHeaderDefaultProps } from './page-header';
import { ContentEntityLayout } from './content-entity-layout';
export var PostBannerLayoutDefaultProps = {
  headerProps: __assign({}, PageHeaderDefaultProps)
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentLayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-top: ", ";\n\n    h1 {\n      font-weight: 500;\n    }\n  "], ["\n    margin-bottom: ", ";\n    margin-top: ", ";\n\n    h1 {\n      font-weight: 500;\n    }\n  "])), theme.UNIT(8), theme.UNIT(8)),
  tablet: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(10)),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(12))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ContentLayout: styled(ContentEntityLayout)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContentLayoutStyles)
};
export var PostBannerLayout = function PostBannerLayout(props) {
  var _a;

  var className = props.className,
      entity = props.entity,
      afterHeader = props.afterHeader,
      headerProps = props.headerProps,
      children = props.children;
  var knowledgeHubPage = useKnowledgeHubPage(); // convert post into a page to provide images and titles from other fields

  var page = __assign(__assign({}, entity), {
    title: entity.name,
    banners: entity.banners
  });

  if (!((_a = page.banners) === null || _a === void 0 ? void 0 : _a.length)) {
    page.banners = page.imageAssets || [];
  }

  return React.createElement(ActiveEntityProvider, {
    value: knowledgeHubPage
  }, React.createElement(My.Container, {
    className: className
  }, React.createElement(PageHeader, __assign({}, headerProps, {
    entity: page
  })), afterHeader, React.createElement(SliceLayoutBoundary, null, React.createElement(My.ContentLayout, {
    showTitles: true,
    showImage: false,
    showShareButtons: true,
    entity: page
  }))));
};
PostBannerLayout.defaultProps = PostBannerLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;